import { useI18n } from "../lib/i18n";

export default function StatusBadge({ status }) {
  const { t } = useI18n();
  const active = status === "active";
  const label = active ? t("status_active") : t("status_pending");
  return (
    <span
      data-testid="status-badge"
      className={`inline-flex items-center gap-1.5 font-mono text-[10px] tracking-widest uppercase px-2.5 py-1 rounded-full border ${
        active
          ? "text-nhgreen border-nhgreen/30 bg-nhgreen/10"
          : "text-nhorange border-nhorange/30 bg-nhorange/10"
      }`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${active ? "bg-nhgreen" : "bg-nhorange"}`} />
      {label}
    </span>
  );
}
